module.exports = __webpack_public_path__ + "static/media/experimentation@3x.ac7c949f.png";